import Whatshot from '@mui/icons-material/Whatshot';
import { Chip, Stack } from '@mui/material';

// Essas cores só serão usadas aqui, por isso não estão no tema
const bgColor = '#D66D22';
const color = '#FFECE0';

export const TrendingChip = () => (
  <Chip
    sx={{
      background: bgColor,
      color: color,
      '& svg': { color: `${color} !important` },
    }}
    label={
      <Stack direction="row" alignItems="center" gap={0.5}>
        Em Alta
        <Whatshot />
      </Stack>
    }
  />
);
